import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
  Typography
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'src/components/Logo';
import { THEMES } from 'src/constants';
import Account from './Account';
import Contacts from './Contacts';
import Notifications from './Notifications';
import Search from './Search';
import Settings from './Settings';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default
        }
      : {})
  },
  toolbar: {
    minHeight: 64
  }
}));

function TopBar({ className, onMobileNavOpen, onHideDesktopSidebar, ...rest }) {
  const classes = useStyles();
  const { user } = useSelector(state => state.account);
  const module =
    user.roles.length && user.roles[0].name.trim() === 'engineering'
      ? 'BUILDING OFFICIAL'
      : user.roles[0].name === 'fire'
      ? 'FIRE'
      : user.roles[0].name === 'admin'
      ? 'ADMINISTRATOR'
      : user.roles[0].name === 'mpdo'
      ? 'ZONING'
      : user.roles[0].name === 'reviewer'
      ? 'REVIEWER'
      : user.roles[0].name === 'treasury'
      ? 'TREASURY'
      : user.roles[0].name === 'structural-reviewer'
      ? 'STRUCTURAL'
      : user.roles[0].name === 'electrical-reviewer'
      ? 'ELECTRICAL'
      : user.roles[0].name === 'plumbing-reviewer'
      ? 'PLUMBING'
      : user.roles[0].name === 'architectural-reviewer'
      ? 'ARCHITECTURAL'
      : user.roles[0].name === 'requirements-reviewer'
      ? 'MODERATOR'
      : user.roles[0].name === 'moderator'
      ? 'MODETOR'
      : user.roles[0].name === 'line-and-grade-reviewer'
      ? 'LINE AND GRADE'
      : user.roles[0].name === 'zoning-reviewer'
      ? 'ZONING'
      : 'APPLICANT';

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
          <Typography style={{ marginLeft: 10 }} variant="caption">
            {module}
          </Typography>
        </Hidden>

        <Hidden mdDown>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onHideDesktopSidebar}
            style={{
              marginRight: '20px'
            }}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>

          <RouterLink to="/">
            <Logo />
          </RouterLink>
          <Typography style={{ marginLeft: 10 }} variant="caption">
            {module}
          </Typography>
        </Hidden>

        <Box ml={2} flexGrow={1} />
        <Hidden xsDown xsUp>
          <Search />
          <Contacts />
        </Hidden>

        {/* notifications */}
        <Notifications />

        <Settings />
        <Box ml={2} id="stepTen">
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
